module.exports = __webpack_public_path__ + "static/media/lr.cf309785.svg";